'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'cup-straw';
var width = 384;
var height = 512;
var aliases = [129380];
var unicode = 'e363';
var svgPathData = ['M52.1 176L76.3 466.7c1.4 16.6 15.2 29.3 31.9 29.3l167.7 0c16.6 0 30.5-12.8 31.9-29.3L331.9 176 52.1 176z', 'M249 0c-18.4 0-34.4 12.5-38.8 30.3L185.8 128 8 128c-4.4 0-8 3.6-8 8s3.6 8 8 8l183.8 0c.1 0 .2 0 .3 0L376 144c4.4 0 8-3.6 8-8s-3.6-8-8-8l-173.8 0 23.5-93.8C228.4 23.5 238 16 249 16l31 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L249 0zM36 176L60.3 468c2.1 24.9 22.9 44 47.8 44l167.7 0c25 0 45.8-19.1 47.8-44L348 176l-16.1 0L307.7 466.7c-1.4 16.6-15.2 29.3-31.9 29.3l-167.7 0c-16.6 0-30.5-12.8-31.9-29.3L52.1 176 36 176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCupStraw = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;